import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import { BasicSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import download from "downloadjs";
import moment from "moment";
import QRCode from "qrcode";
import jsPDF from "jspdf";
import utils from "../../../utils/validateScanner";

export default {
  name: "CameraConfig",
  mixins: [utils],
  components: {
    BasicSelect,
    Multiselect,
    VueElementLoading,
    download,
  },
  data: function () {
    return {
      hubId: "",
      FacilityName: "",
      ZoneType: "",
      Layout: "",
      BayZone: "",
      CameraName: "",
      createdBy: "",
      componentKey: 0,
      isLoadingUpload: false,
      isLoadingSearch: false,
      failed: [],
      fileDetails: [],
      addmodalShow: false,
      selectedConfig: "",
      configFileLogs: [],
      showModal: false,
      url: "",
      configFile: "",
      currentTab: "print",
      tabs: [
        {
          key: "upload",
          value: "Facility Camera Config",
        },
        {
          key: "history",
          value: "History",
        },
        {
          key: "print",
          value: "Print QR Code Sticker",
        },
      ],
      expectedColumns: [
        "Facility Name",
        "Zone Type",
        "Layout *",
        "Bay / Zone",
        "Camera Name",
      ],
      validZoneTypes: [
        "D2B",
        "Secondary Sort",
        "Bagout Shipments",
        "Manifest Inscan",
      ],


      activelayout: false,
      listZoneTypeData: [],
      zoneType: [],
      listZoneNameData: [],
      zoneName: [],
      qrZoneDetails: [],
      qrPreviewList: [],
      hubLoading: "",
      isLoading:false,
      isCameraAccess:false,
      hubName: ""
    };
  },
  computed: {
    currentTabComponent: function () {
      this.componentKey += 1;
      return this.currentTab.toLowerCase();
    },
  },
  watch: {
    roleconfig(newVal) {

    if (newVal && Object.keys(newVal).length) {


      this.isCameraAccess = this.validateUserRole(
        newVal.camera_config_role
      );
      this.currentTab = this.isCameraAccess ? 'upload' : 'print';
    }
  }
  },
  filters: {
    moment: function (date) {
      if (date == "" || date == null) {
        return "--";
      }
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    moment1: function (timestamp) {
      const convertTimestamp = new Date(timestamp)
        .toLocaleString("en-GB", {
          timeZone: "UTC",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/, "$1-$2-$3 $4:$5:$6");
      return convertTimestamp;
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdBy = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
    this.getHubName(userdetail[0].HubId);
    this.hubForManualRestriction();
  },
  methods: {
    secondFunction(tab) {
      this.currentTab = tab.key;
      this.componentKey++;
      if ((tab.key === 'upload' || tab.key === 'history') && !this.isCameraAccess) {
        return; 
      }
      if (tab.key == "history") {
        this.resetForm();
        this.getConfigFile();
      }
      if (tab.key == "print") {
        this.resetForm();
        this.getZoneType();
        this.resetPrint();
      }
    },
    		getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName
          }
        }, error => {
          console.error(error)
        })
    },

    
    uploadConfigFile(event) {
      this.failed = [];
      this.selectedFile = event.target[0].elements[0].files[0];

      if (this.selectedFile.size > 5242880) {
        this.$alertify.error(
          "Failed! Upload Max File Size Should Not Be Greater Than 5 MB",
        );
        return false;
      } else if (
        /\.(csv)$/i.test(this.selectedFile.name) ||
        /\.(zip)$/i.test(this.selectedFile.name)
      ) {
        this.isLoadingUpload = true;

        const fd = new FormData();
        fd.append("hubId", this.hubId);
        fd.append("hubName", this.hubName);
        fd.append("uploadedBy", this.createdBy);
        fd.append("fileData", this.selectedFile);
        fd.append("fileName", this.selectedFile.name);
        axios
          .post(apiUrl.api_url_hubops + "cameraConfig/upload", fd, {
            headers: {
              Authorization: "authkey xB84JJ89Hd25",
            },
          })
          .then(
            (result) => {
              if (result.data.ResultCode == 100) {
                this.$alertify.success(result.data.ReturnMessage);
                this.resetForm();
              } else {
                this.$alertify.error(result.data.ReturnMessage);
              }

              if (
                result &&
                result.data.failed &&
                result.data.failed.length > 0
              ) {
                this.failed = result.data.failed
              }

              this.isLoadingUpload = false;
            },
            (error) => {
              console.error(error);
              this.isLoadingUpload = false;
              this.$alertify.error("Error Occured");
            },
          );
      } else {
        this.isLoadingUpload = false;
        this.$alertify.error(
          "Failed! Please Upload Only Valid Format: .csv OR .zip",
        );
      }
    },

    onUploadSubmit: function (res) {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.uploadConfigFile(event);
            event.target.reset();
          }
        })
        .catch((error) => {
          this.$alertify.error("Error Occured");
        });
    },

    downloadConfig(file) {
      if (file.createdby == "AUTOMATED-TRIGGER") {
        this.downloadConfigbySingedUrl(file);
      } else {
        this.downloadConfigfromDB(file);
      }
    },

    downloadConfigfromDB(file) {
      let fileData = [];
      this.isLoadingSearch = true;

      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "cameraConfig/downloadConfigData?hubId=" +
          this.hubId +
          "&fileId=" +
          file.id,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.isLoadingSearch = false;

            fileData = result.data.ResponseData;
            let fileName = file.filename;
            let csvFields = {
              facility_name: "Facility Name",
              zone_type: "Zone Type",
              layout: "Layout",
              bay_zone: "Bay/ Zone",
              camera_name: "Camera Name",
            };
            fileData = fileData.map((item) => ({
              facility_name: item.facility_name,
              zone_type: item.zone_type,
              layout: item.layout,
              bay_zone: item.bay_zone,
              camera_name: item.camera_name,
            }));
            this.jsonToCSV(fileName, fileData, csvFields);
            this.$alertify.success("Success");
          } else {
            this.isLoadingSearch = false;
            this.$alertify.error(result.data.ReturnMessage);
          }
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    downloadConfigbySingedUrl(file) {
      let fileData = [];
      this.isLoadingSearch = true;
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "generateSorterConfigSignedUrl?fileName=" +
          file.filename +
          "&fileType=" +
          file.filetype +
          "&sorterHubId=" +
          file.sorterhubid,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.isLoadingSearch = false;
            this.url = result.data.ResponseData;
            var link = document.createElement("a");
            link.href = result.data.ResponseData;
            link.download = this.url;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.isLoadingSearch = false;
            this.$alertify.error(result.data.ReturnMessage);
          }
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    async exportFailedConfig() {
      this.isLoadingUpload = true;

      let fileName = "failedConfig";
      let csvFields = {
        error: "Error Message",
      };
       csvFields = {
				  "Facility Name": "Facility Name",
          "Zone Type": "Zone Type",
          "Layout": "Layout",
          "Bay/ Zone": "Bay/ Zone",
          "Camera Name": "Camera Name",
          "Reason": "Reason"
      }

      await this.jsonToCSV(fileName, this.failed, csvFields);
      this.isLoadingUpload = false;
    },

    selectFile(data) {
      this.selectedConfig = data;
      if (data.isactive) {
        this.$alertify.error("Config is already Active");
        return;
      }
      this.addmodalShow = true;
    },

    takeAction() {
      this.addmodalShow = false;
      this.updateConfigStatus();
    },

    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = "";

      if (filename != "failedConfig")
        // csvData += "Config Name" + "," + filename + "\n";
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, "${data}\r\n");
      }
      //Fields
      const fieldKeys = Object.keys(csvfield).filter(
        (key) => skipFilter.indexOf(key) === -1,
      );
      csvData += fieldKeys.map((key) => csvfield[key]).join(",") + "\r\n";
      //Data
      data.forEach(function (item) {
        csvData += fieldKeys
          .map((key) => {
            let value = item[key];
            if (value === null || value === undefined) return "";
            let escapedCSV = value + "";
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
            }
            if (escapedCSV == "null") return "";
            return dateFilder.indexOf(key) != -1
              ? moment(escapedCSV).format("DD-MM-YYYY HH:mm:ss")
              : escapedCSV;
          })
          .join(",");
        csvData += "\r\n";
      });
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, "${data}\r\n");
      }
      if(filename === "failedConfig") {
          filename += ".csv";
      }
      return this.export(csvData, filename, "application/csv");
      return csvData;
    },


    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },


    updateConfigStatus() {
      this.isLoadingSearch = true;
      let fileInput = {
        fileId: this.selectedConfig.id,
        hubId: this.hubId,
        isActive: true,
        updatedBy: this.createdBy,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "cameraConfig/toggleActive",
        data: fileInput,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.getConfigFile();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },


    closeStatusModal() {
      this.addmodalShow = false;
      this.selectedConfig = "";
    },


    getCameraConfigLogs(data) {
      this.isLoadingSearch = true;

      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "cameraConfig/facility?hubId=" +
          this.hubId +
          "&fileId=" +
          data.id,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.configFileLogs = result.data.ResponseData;
            this.isLoadingSearch = false;
            this.showModal = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },


    closeModal() {
      this.showModal = false;
      this.configFileLogs = [];
    },


    getConfigFile() {
      this.isLoadingSearch = true;
      this.fileDetails = [];
      axios({
        method: "GET",
        url: apiUrl.api_url_hubops + "cameraConfig/history?hubId=" + this.hubId,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.fileDetails = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    getCameraConfigQRList() {
      this.isLoadingSearch = true;
      let zoneTypeIds = '';

       if (this.zoneType && this.zoneType.length > 0) {
         zoneTypeIds = this.zoneType.map(item => item.id).join(',');
         }
      let url =
        apiUrl.api_url_hubops +
        "cameraConfig/zoneCameraList?hubId=" +
        this.hubId +
        "&zoneTypeId=" +
        zoneTypeIds;

      if (this.zoneName && this.zoneName.length > 0) {
        const bayZoneIds = this.zoneName.map(item => item.id).join(',');
        url += "&bayZoneId=" + bayZoneIds;
      }
      axios({
        method: "GET",
        url:url,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.qrZoneDetails = result.data.ResponseData;
            
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },



    selectZoneType(selectedList) {
      this.zoneName = [];
      this.listZoneNameData = [];
      if(!selectedList || selectedList.length === 0) {
        this.qrZoneDetails = [];
        return;
      }
      this.zoneType = selectedList;
      if (this.zoneType && this.zoneType.length > 0) {
        const zoneTypeIds = this.zoneType.map(item => item.id).join(',');
        this.getZoneName(zoneTypeIds);
      }
        this.getCameraConfigQRList();
    },

    selectZoneName(selectedList) {
      this.zoneName = selectedList;
      this.getCameraConfigQRList();
    },

    getZoneType() {
      this.hubLoading = "Loading zone type...";
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops + "cameraConfig/zoneTypes?hubId=" + this.hubId,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.listZoneTypeData = result.data.ResponseData;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.hubLoading = "";
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
          this.hubLoading = "";
        },
      );
    },

    getZoneName(zoneTypeIDs) {
      this.hubLoading = "Loading zone names...";
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "cameraConfig/bayZones?hubId=" +
          this.hubId +
          "&zoneTypeId=" +
          zoneTypeIDs,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.listZoneNameData = result.data.ResponseData;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.hubLoading = "";
        },
        (error) => {
          console.error(error);
          this.hubLoading = "";
        },
      );
    },

    resetForm(event) {
      this.isLoadingUpload = false;
      this.isLoadingSearch = false;
      this.filetype = "";
      this.configFile = "";
      this.failed = [];
      this.$validator.reset();
      this.errors.clear();
      if (event && event.target && event.target.form) {
        event.target.form.reset();
      }
    },


    async printQRs() {
          if (this.qrZoneDetails.length === 0) {
            this.$alertify.error("Please select at least one zone.");
            return;
          }

          // Layout configuration — single source of truth
          const LAYOUT = {
            margin: 10,
            perRow: 2,        // columns per row
            rowsPerPage: 3,   // rows per page
            labelHeight: 20,
            cellPadding: 5,
          };

          const pdf = new jsPDF();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Available space after margins
          const availableWidth = pageWidth - LAYOUT.margin * (LAYOUT.perRow + 1);
          const availableHeight = pageHeight - LAYOUT.margin * (LAYOUT.rowsPerPage + 1) - LAYOUT.labelHeight * LAYOUT.rowsPerPage;

          // Derive QR size — take the smaller dimension to keep QRs square and perfectly fitting
          const qrFromWidth = availableWidth / LAYOUT.perRow;
          const qrFromHeight = availableHeight / LAYOUT.rowsPerPage;
          const qrSize = Math.min(qrFromWidth, qrFromHeight); // square, fits both axes

          const cellHeight = qrSize + LAYOUT.labelHeight;
          const qrsPerPage = LAYOUT.perRow * LAYOUT.rowsPerPage;

          let count = 0;

          for (const preview of this.qrZoneDetails) {
            const label =
              `${preview.zone_type}\n` +
              `Zone/Bay: ${preview.bay_zone}\n` +
              `${preview.qr_string}`;
            const wrappedText = pdf.splitTextToSize(label, qrSize - LAYOUT.cellPadding * 2);

            if (count > 0 && count % qrsPerPage === 0) {
              pdf.addPage();
            }

            const posOnPage = count % qrsPerPage;
            const col = posOnPage % LAYOUT.perRow;
            const row = Math.floor(posOnPage / LAYOUT.perRow);

            const x = LAYOUT.margin + col * (qrSize + LAYOUT.margin);
            const y = LAYOUT.margin + row * (cellHeight + LAYOUT.margin);

            const url = await QRCode.toDataURL(preview.qr_string);
            pdf.addImage(url, "PNG", x, y, qrSize, qrSize);
            pdf.rect(x, y, qrSize, cellHeight);
            pdf.setFontSize(9);
            pdf.text(wrappedText, x + LAYOUT.cellPadding, y + qrSize + LAYOUT.cellPadding);

            count++;
          }

          pdf.save("qr-codes.pdf");
        }
,
    resetPrint() {

      this.qrZoneDetails=[]
      // Clear form fields
      this.zoneType = [];
      this.zoneName = [];

      // Clear validation errors
      this.$validator.reset();
      this.errors.clear();

    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/CameraMaster/CameraMaster.js